// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__353zJ","header":"PatientBlock_header__1sjgh","label":"PatientBlock_label__3qEhv","option":"PatientBlock_option__3_dgy"};